import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getDiets } from "@/features/diets/api/get-diets";
import type { DietCatalog } from "@/features/diets/types";
import type { DietsFiltersType } from "@/features/diets/types/dites-filtes.type";
import type { ApiPlatformResponseType } from "@/types/api-platform.type";

type UseDietsParams = {
  filters?: DietsFiltersType;
  options?: Omit<
    UseQueryOptions<
      ApiPlatformResponseType<DietCatalog>,
      unknown,
      ApiPlatformResponseType<DietCatalog>,
      string[]
    >,
    "queryFn" | "queryKey"
  >;
  callback?: (data: DietCatalog[]) => void;
};

const useDiets = ({ filters, options, callback }: UseDietsParams) => {
  return useQuery({
    queryKey: ["diets", JSON.stringify(filters)],
    queryFn: async () => {
      const diets = await getDiets(filters);
      if (callback) {
        callback(diets["hydra:member"]);
      }
      return diets;
    },
    ...options,
  });
};

export { useDiets };
